module.exports = __webpack_public_path__ + "static/media/request-quote-form.afb57143.png";